import { Suspense } from "react";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import Routes from "./Router/route";
import { darkTheme, lightTheme } from "./theme";
import { themeModeSelector } from "./States/Slice/Settings.state";
import { useAppSelector } from "./States";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RTL } from "./muiRtl";
import { Scrollbars } from "react-custom-scrollbars-2";
import { SplashScreenLayout } from "./Components/Layouts/SplashScreen.layout";
import ErrorBoundary from "./Components/Layouts/ErrorBoundary/ErrorBoundary";

function App() {
  const themeMode = useAppSelector(themeModeSelector);

  return (
    <RTL>
      <ThemeProvider theme={themeMode === "dark" ? darkTheme : lightTheme}>
        <CssBaseline />
        <Box
          sx={{
            ".scroll > div:first-of-type": {
              marginRight: "-17px !important",
              marginLeft: "0 !important",
            },
          }}
        >
          <Scrollbars
            className="scroll"
            style={
              {
                width: "100%",
                height: "100vh",
                overflow: "hidden",
              } as any
            }
          >
            <ErrorBoundary>
              <Suspense fallback={<SplashScreenLayout />}>
                <Routes />
              </Suspense>
            </ErrorBoundary>
          </Scrollbars>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover
            theme={themeMode}
          />
        </Box>
      </ThemeProvider>
    </RTL>
  );
}

export default App;
